export const emptyMessage = "Não existem dados a serem exibidos.";
export const errorMessage = "Ocorreu um erro ao obter os dados, recarregue a tela por favor."